// Generated by Claude Code
/** The `<dialog>` an element sits in. A panel portalled there stays in the dialog's top layer instead of behind it. */
export function floatingRoot(element: Element | null | undefined): HTMLElement | undefined {
  return element?.closest('dialog') ?? undefined
}
